import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'

import messages from './messages'


// TODO seems it's a Dialog modal (not 'WithActions')
export default class ReactivateSubscriptionModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.resubscribe.ReactivateSubscription,
  }

  constructor() {
    super()

    this.actions = [
      {
        brand: true,
        title: messages.buttonTitle,
        onClick: this.handleClick,
        dataTestId: constants.testIds.modal.dialogModal.button,
      },
    ]
  }

  handleClick = () => {
    const { name } = this.props

    actions.models.modals.close(name)

    actions.models.subscription.resubscribe({ popup: 'reactivate subscription modal' })
      .then(({ premiumProduct }) => {
        if (premiumProduct) {
          actions.models.modals.open(constants.modals.premiumProducts.WelcomeBack, {
            item: premiumProduct,
          })
        }
        else {
          actions.models.modals.open(constants.modals.resubscribe.ResubscribeSuccess)
        }
      }, () => {})
  }

  render() {
    const { name } = this.props

    return (
      <ModalWithActions
        name={name}
        title={messages.title}
        actions={this.actions}
      >
        <FormattedHTMLMessage {...messages.text} />
      </ModalWithActions>
    )
  }
}
